// This file contains all config options shared between configs

// Be sure to edit next.config.js if you change this
export const locales = ['en', 'es'] as const;
export type Locales = (typeof locales)[number];
export const defaultLocale = 'en';
export const localePrefix = 'as-needed';
